import { createInstance } from "../api";

export function fetchPTZMoveControl(channel, direction, speed, recordIP) {
  console.log(channel, direction, speed, recordIP);
  const instance = createInstance(recordIP);
  return instance.post(
    `ptz/${channel}/move/${direction}`,
    {},
    {
      params: { speed },
    }
  );
}

export function fetchPTZZoomControl(channel, mode, recordIP) {
  console.log(channel, mode, recordIP);
  const instance = createInstance(recordIP);
  return instance.post(`ptz/${channel}/zoom/${mode}`);
}
